// react
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// components
import { ClientReferralStartPage } from '@karehero/llama/pwa/pages/ClientReferralStartPage/ClientReferralStartPage';

// hooks
import { useGoBack } from 'hooks/useGoBack';

// store
import { useSelector } from 'store';
import {
  ClientData,
  setClientData,
  getClientData,
} from 'store/slices/clientReferralSlice';

// router
import { ROUTES } from 'router';

/**
 * ClientReferralStart wires the ClientReferralStartPage to the client referral flow
 */
export const ClientReferralStart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const goBack = useGoBack();
  const clientData = useSelector(getClientData);

  const onSubmit = useCallback(
    async (data: ClientData) => {
      dispatch(setClientData(data));
      navigate(ROUTES.PORTAL_CLIENT_REFERRAL_LEAD_DATA);
    },
    [dispatch, navigate],
  );

  return (
    <ClientReferralStartPage
      onBack={goBack}
      onSubmit={onSubmit}
      initialValues={clientData || undefined}
    />
  );
};

export default ClientReferralStart;
